import API from "@/services/api";

export default{
    getSrcUsers(){
        return API().get("users/src/all");
    },
    getAdminUsers(){
        return API().get("users/admin/all");
    },
    getUser(id){
        return API().get(`users/${id}`);
    },
    updateUser(id,payload){
        return API().put(`users/${id}`,payload);
    }
}